import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { FaUser } from "react-icons/fa";
import { RiLockPasswordFill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import CryptoJS from 'crypto-js';
export default function Login() {
    const [Phone, setPhone] = useState(''); // Initialize as empty string
    const [password, setPassword] = useState(''); // Initialize as empty string
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const gettoken = localStorage.getItem('token');
    const getId = localStorage.getItem('_id');
    const role = localStorage.getItem('role');
 useEffect(()=>{
    if(gettoken && getId && role){
        navigate("/home");
    }
    else{
        navigate("/");
        localStorage.clear();
    }
 },[])
 const encryptData = (data) => {
    const secretKey = 'asdfghjklpoiuytrewq1234567890zxcvbnm'; // Make sure the secret key is kept safe
    return CryptoJS.AES.encrypt(data, secretKey).toString();
};
const submit = async (e) => {
    e.preventDefault(); 
    setLoading(true);
    setError(null);

    try {
        // Make sure the API URL is correctly set in your .env file
        const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/api/auth/login`,
            { 
                Phone: Number(Phone), 
                Password:password 
            }
        );

        console.warn(response.data.message);

        // Save response data to local storage
        localStorage.setItem('_id', response.data.user._id);
        localStorage.setItem('token', response.data.token);
        localStorage.setItem("role", response.data.user.user_type);

        // Show success message and navigate
        Swal.fire(response.data.message, "", "success");

        navigate("/home");
    } catch (err) {
        console.warn(err)
        Swal.fire(err.response && err.response.data.message); // Corrected the typo in "Failed"
        setError(err.response ? err.response.data.message : 'Login failed'); 
    } finally {
        setLoading(false);
    }
};


    const handlePhoneChange = (e) => {
        setPhone(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    return (
        <div className="loginpagenew">
            <div className="wrapper">
                <form onSubmit={submit}>
                    <h1>Login</h1>
                    <div className="input-box">
    <div className="form-group">
        <input
            type="text"
            placeholder="Phone"
            // autoComplete="new-Phone" // Use a unique value
            onChange={handlePhoneChange}
            className="form-control"
            required
        />
    </div>
    <FaUser/>
</div>
<div className="input-box">
    <div className="form-group">
        <input
            type="password"
            placeholder="Password"
            autoComplete="new-password" // Use a unique value
            onChange={handlePasswordChange}
            className="form-control"
            required
        />
            </div>
        <RiLockPasswordFill/>
        </div>

                    <div className="remember-forgot">
                        <label>
                            <input type="checkbox" />
                            Remember me
                        </label>
                        <a href="#">Forgot password?</a>
                    </div>
                    <button type="submit" className="btn" disabled={loading}>
                        {loading ? 'Logging in...' : 'Login'}
                    </button>
                    {/* {error && <p style={{ color: 'red' }}>{error}</p>} */}
                    <div className="register-link">
                        <p>
                            Don't have an account? <a href="#">Register</a>
                        </p>
                    </div>
                </form>
            </div>
        </div>
    );
}
